import { render, staticRenderFns } from "./ReadyFinance.vue?vue&type=template&id=6968dd53&"
import script from "./ReadyFinance.vue?vue&type=script&lang=ts&"
export * from "./ReadyFinance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports